import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const FeatureHeader = () => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    alignItems={{ xs: "flex-start", sm: "center" }}
    justifyContent="space-between"
    spacing={2}
    mb={3}
  >
    <Box>
      <Typography variant="h4" sx={{ fontSize: "24px" }} fontWeight={700} color="#1f2937">
        Feature Requests
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Share ideas, vote on priorities, and follow delivery progress.
      </Typography>
    </Box>
  </Stack>
);

export default FeatureHeader;
